// extracted by mini-css-extract-plugin
module.exports = {"arc-meter":"ArcMeter_arc-meter__K6g2a","indicator":"ArcMeter_indicator__ZnANC"};